import React, { useRef } from "react";
import { Form } from "react-bootstrap";

const FileDropZone = ({ file, setFile, onFileSelect, isDark }) => {
  const fileInputRef = useRef();

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const droppedFile = e.dataTransfer.files[0];
      setFile(droppedFile);
      onFileSelect(droppedFile);
      e.dataTransfer.clearData();
    }
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleClick = () => fileInputRef.current.click();

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      onFileSelect(selectedFile);
    }
    e.target.value = "";
  };

  return (
        <div
        className="border p-4 rounded mb-3"
        style={{
            cursor: "pointer",
            backgroundColor: isDark ? "#2a2a2a" : "#f8f9fa",
            borderColor: isDark ? "#555" : "#dee2e6",
            transition: "all 0.3s ease",
        }}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
        >

        {file ? (
        <p
            className="mb-0"
            style={{
            color: isDark ? "#ffffff" : "#000000",
            transition: "color 0.3s ease",
            }}
        >
            {file.name}
        </p>
        ) : (
        <p
            className="mb-0"
            style={{
            color: isDark ? "#cccccc" : "#6c757d", // bright gray for dark, muted for light
            transition: "color 0.3s ease",
            }}
        >
            Drag & drop a file here, or click to select
        </p>
        )}

      <Form.Control
        type="file"
        onChange={handleChange}
        ref={fileInputRef}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default FileDropZone;
